module.exports = __webpack_public_path__ + "img/cornerRightTop.e396ec6a.svg";